export default __webpack_public_path__ + "static/media/profileImg_2.173aad08.png";